import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Social from "./Social";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/events", label: "Events" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

const LOGO_SRC = "/sunstate/logo.png";

export const Layout = ({ children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <div className="sc-app">
      <header className="sc-nav" data-testid="site-nav">
        <div className="sc-nav-inner">
          <Link to="/" className="sc-nav-brand" data-testid="nav-brand">
            <img src={LOGO_SRC} alt="Sunstate Collective" />
            <span className="sc-nav-brand-text">
              <span className="sc-nav-brand-name">SUNSTATE</span>
              <span className="sc-nav-brand-sub">COLLECTIVE</span>
            </span>
          </Link>

          <nav className="sc-nav-links" aria-label="Primary">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `sc-nav-link ${isActive ? "is-active" : ""}`
                }
                data-testid={`nav-link-${item.label.toLowerCase()}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/events"
              className="sc-nav-cta"
              data-testid="nav-enquire-btn"
            >
              ENQUIRE
            </Link>
          </nav>

          <button
            type="button"
            className="sc-nav-toggle"
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
            data-testid="nav-toggle"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {open && (
          <div className="sc-nav-mobile" data-testid="nav-mobile-menu">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `sc-nav-mobile-link ${isActive ? "is-active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/events" className="sc-nav-mobile-cta">
              ENQUIRE
            </Link>
          </div>
        )}
      </header>

      <main className="sc-main">{children}</main>

      <footer className="sc-footer" data-testid="site-footer">
        <div className="sc-footer-inner">
          <div className="sc-footer-brand">
            <img src={LOGO_SRC} alt="Sunstate Collective" />
            <p className="sc-footer-tag">
              Luxury event planning, styling &amp; coordination
            </p>
          </div>

          <div className="sc-footer-cols">
            <div className="sc-footer-col">
              <h4>Explore</h4>
              <Link to="/">Home</Link>
              <Link to="/events">Events</Link>
              <Link to="/about">About</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div className="sc-footer-col">
              <h4>Services</h4>
              <Link to="/events">Hotel &amp; Airbnb Setups</Link>
              <Link to="/events">Picnics</Link>
              <Link to="/events">Home Celebrations</Link>
              <Link to="/events">Corporate Events</Link>
              <Link to="/events">Proposals</Link>
              <Link to="/events">Venue Celebrations</Link>
            </div>
            <div className="sc-footer-col">
              <h4>Contact</h4>
              <a href="mailto:sunstatecollective@gmail.com">
                sunstatecollective@gmail.com
              </a>
              <span>Gold Coast &amp; Brisbane, QLD</span>
              <span>Australia</span>
              <Social variant="icons-only" className="sc-footer-social" testId="footer-social" />
            </div>
          </div>
        </div>

        <div className="sc-footer-base">
          <span>
            &copy; {new Date().getFullYear()} Sunstate Collective &nbsp;·&nbsp;
            Gold Coast &amp; Brisbane, QLD
          </span>
          <span className="sc-footer-fineprint">
            ABN: 72 698 198 775 &nbsp;·&nbsp; All bookings subject to our T&amp;Cs
          </span>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
